export function initCustomDropdown() {
    return [...document.querySelectorAll('.wpcf7-select.custom-select:not(.-initialized)')].map(el => new CustomDropdown(el));
}

export class CustomDropdown {
    _dom = {
        selectElement: null,
        customDropdown: null,
        selectedOption: null,
        optionsContainer: null,
        checkboxWrapper: null,
    };

    constructor(el) {
        if (!el) return;

        this._dom.selectElement = el;
        this._createCustomDropdown();
        this._initEvents();
        this._initCheckboxes(); // Initialize checkboxes
    }

    _createCustomDropdown() {
        // Create the custom dropdown container
        this._dom.customDropdown = document.createElement('div');
        this._dom.customDropdown.classList.add('custom-dropdown');

        // Create the selected option div
        this._dom.selectedOption = document.createElement('div');
        this._dom.selectedOption.classList.add('selected-option');
        this._dom.selectedOption.textContent = 'Please select';

        // Create the options container div
        this._dom.optionsContainer = document.createElement('div');
        this._dom.optionsContainer.classList.add('dropdown-options');

        // Populate custom dropdown options from select element
        Array.from(this._dom.selectElement.options).forEach(option => {
            const customOption = document.createElement('div');
            customOption.classList.add('dropdown-option');
            customOption.textContent = option.textContent;
            customOption.dataset.value = option.value;
            this._dom.optionsContainer.appendChild(customOption);
        });

        // Append the selected option and options container to the custom dropdown
        this._dom.customDropdown.appendChild(this._dom.selectedOption);
        this._dom.customDropdown.appendChild(this._dom.optionsContainer);

        // Insert the custom dropdown into the DOM after the select element
        this._dom.selectElement.parentElement.appendChild(this._dom.customDropdown);

        // Hide the original select element
        this._dom.selectElement.style.display = 'none';
    }

    _initEvents() {
        // Toggle the dropdown on clicking the selected option
        this._dom.selectedOption.addEventListener('click', this._toggleDropdown);

        // Handle clicks on each custom option
        this._dom.optionsContainer.querySelectorAll('.dropdown-option').forEach(option => {
            option.addEventListener('click', this._selectOption);
        });

        // Close dropdown when clicking outside
        document.addEventListener('click', this._closeDropdownOutside);
    }

    _toggleDropdown = () => {
        this._dom.customDropdown.classList.toggle('open'); // Use 'open' class for caret rotation
        this._dom.optionsContainer.classList.toggle('active');
    }

    _selectOption = (event) => {
        const option = event.target;
        this._dom.selectedOption.textContent = option.textContent;
        this._dom.selectElement.value = option.dataset.value;
        this._dom.optionsContainer.classList.remove('active');
        this._dom.customDropdown.classList.remove('open'); // Ensure caret rotates back
    }

    _closeDropdownOutside = (event) => {
        if (!this._dom.customDropdown.contains(event.target)) {
            this._dom.optionsContainer.classList.remove('active');
            this._dom.customDropdown.classList.remove('open'); // Ensure caret rotates back
        }
    }

    _initCheckboxes() {
        // Function to handle checkbox change
        const handleCheckboxChange = (event) => {
            const checkbox = event.target;
            const checkboxWrapper = checkbox.closest('.wpcf7-form-control');

            if (checkboxWrapper && checkboxWrapper.classList.contains('checkbox-toggle')) {
                if (checkbox.checked) {
                    checkboxWrapper.classList.add('checked');
                } else {
                    checkboxWrapper.classList.remove('checked');
                }
            }
        }

        // Add event listener to all checkboxes with the "checkbox-toggle" class
        const checkboxes = document.querySelectorAll('.wpcf7-form-control.checkbox-toggle input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', handleCheckboxChange);
        });
    }
}